var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFD7-Grundlagen:-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-652.000000, -2874.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atom/icon/16px/sex/female",
    transform: "translate(652.000000, 2874.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(4.000000, 1.000000)",
    stroke: "#242F38",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,4.00014814 C8,6.20916262 6.20921481,8 4,8 C1.79078519,8 0,6.20928114 0,4.00014814 C0,1.79057072 1.79078519,0 4,0 C6.20921481,0 8,1.79071886 8,4.00014814",
    id: "Combined-Shape",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 8.75,
    x2: 4,
    y2: 14,
    id: "Path",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 12,
    x2: 7,
    y2: 12,
    id: "Path",
    strokeWidth: 1.75
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.40793e10a524d1bee132ce197b3df99a.svg";
export { ForwardRef as ReactComponent };